import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// elements
import LabelWrapper from '../../elements/labelWrapper'
import Grid from '../../elements/grid'
import DateTime from '../../elements/datetime'
import DropDown from '../../elements/dropDown'

// Utils
import { translation } from '../../../utils/helpers'

class DateTimePeriod extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dateFrom: null,
      dateTo: null,
      dateFrom_hour: null,
      dateTo_hour: null
    }

    this.makeTime = this.makeTime.bind(this)
    this.onDateChange = this.onDateChange.bind(this)
    this.onTimeChange = this.onTimeChange.bind(this)
  }

  componentDidMount () {
    this.setState({
      dateFrom: moment(this.props.dateFrom),
      dateTo: moment(this.props.dateTo),
      dateFrom_hour: this.makeTime(this.props.dateFrom),
      dateTo_hour: this.makeTime(this.props.dateTo)
    })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.dateFrom !== this.props.dateFrom || moment(nextProps.dateFrom) !== this.state.dateFrom) {
      this.setState({
        dateFrom: moment(nextProps.dateFrom),
        dateFrom_hour: this.makeTime(nextProps.dateFrom)
      })
    }
  }

  makeTime (date) {
    let time = moment(date).format('HH:mm')
    return time
  }

  onDateChange (name, date) {
    // Set date and reset time
    let timeName = `${name}_hour`
    // let newDateTime = moment(date).hour(0).minute(0)
    this.setState({
      [name]: date,
      [timeName]: '-'
    }, () => {
      console.log('onDateChange', name, timeName, this.state)
    })
    // this.props.onChangePeriod(`${this.props.name}_${name}`, newDateTime)
    if (this.props.onChangeDate) this.props.onChangeDate(name, date)
  }

  onTimeChange (e) {
    let previousTime = this.state[e.target.name]
    this.setState({
      [e.target.name]: e.target.value
    })
    // from/to
    let dateTimeSet = e.target.name.indexOf('From') > -1 ? 'from' : 'to'

    // Combine selected date and time and send to handler.
    let date = this.state[e.target.name.split('_')[0]]
    let hours = e.target.value.split(':')[0]
    let minutes = e.target.value.split(':')[1]
    let combined = moment(date).hours(parseInt(hours)).minutes(parseInt(minutes))

    let dateTimeSetName = `${this.props.name}_${dateTimeSet}`
    if (this.props.onValidation(dateTimeSetName, combined)) {
      // console.log('onTimeChange', dateTimeSetName, combined.format('YYYY-MM-DD HH:mm'))
      this.props.onChangePeriod(dateTimeSetName, combined)
    } else {
      this.setState({
        [e.target.name]: previousTime
      })
    }
  }

  render () {
    // let dateFrom = moment(this.props.dateFrom)
    // let dateTo = moment(this.props.dateTo)
    // let timeFromString = this.state. this.makeTime(this.props.dateFrom)
    // let timeToString = this.makeTime(this.props.dateTo)

    const mapTimes = (val, index) => {
      return (
        <option key={index} value={val}>{val}</option>
      )
    }
    return (
      <div className='datetime-period'>
        <LabelWrapper labelText={translation('16771')}>
          <Grid cols={[2, 1]}>
            <DateTime
              closeOnSelect
              timeFormat={false}
              value={this.state.dateFrom}
              isValidDate={this.props.onlyValidAfterCurrentDate ? x => new Date(x) >= new Date().setHours(0, 0, 0, 0) : undefined}
              inputProps={{
                name: 'dateFrom',
                disabled: this.props.disabled
              }}
              onChange={this.onDateChange.bind(this, 'dateFrom')}
            />
            <DropDown name='dateFrom_hour' value={this.state.dateFrom_hour} disabled={this.props.disabled} onChange={this.onTimeChange}>
              <option key={-1} value={'-'} label={translation(16821)} disabled />
              {this.props.timesFrom.map(mapTimes)}
              {this.props.disabled && [this.state.dateFrom_hour].map(mapTimes)}
            </DropDown>
          </Grid>
        </LabelWrapper>
        <LabelWrapper labelText={translation('16772')}>
          <Grid cols={[2, 1]}>
            <DateTime
              closeOnSelect
              timeFormat={false}
              value={this.state.dateTo}
              isValidDate={this.props.onlyValidAfterCurrentDate ? x => new Date(x) >= new Date().setHours(0, 0, 0, 0) : undefined}
              inputProps={{
                name: 'dateTo',
                disabled: this.props.disabled
              }}
              onChange={this.onDateChange.bind(this, 'dateTo')}
            />
            <DropDown name='dateTo_hour' value={this.state.dateTo_hour} disabled={this.props.disabled} onChange={this.onTimeChange}>
              <option key={-1} value={'-'} label={translation(16821)} disabled />
              {!this.props.disabled && this.props.timesTo.map(mapTimes)}
              {this.props.disabled && [this.state.dateTo_hour].map(mapTimes)}
            </DropDown>
          </Grid>
        </LabelWrapper>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {}
}

DateTimePeriod.defaultProps = {
  name: 'dateTimePeriod',
  onValidation: (dateTime) => { return true },
  onlyValidAfterCurrentDate: false
}

export default connect(mapStateToProps, { })(DateTimePeriod)



// WEBPACK FOOTER //
// ./src/app/shared/components/DateTimePeriod/index.js